export default "/imgs/investigation-01-mob.png"